export const getUrl = (key: string): string => {
  return `${process.env.NEXT_PUBLIC_CDN_URL}/uploads/${key}`.replace(/(?<!https?:)\/\//g, "/");
};

export const getImageOrFallback = (fallback: string, key?: string): string => {
  if (!key) {
    return fallback;
  }
  return getUrl(key);
};

export const staticUrl = (key: string): string => {
  return `${process.env.NEXT_PUBLIC_CDN_URL}/${key}`.replace(/(?<!https?:)\/\//g, "/");
};